import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ff8c7d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  key: 0,
  class: "handle-content"
};
import { getPayChnlList } from '@/api/payManage/domian';
import SvgIcon from '@/components/SvgIcon.vue';
import AddOrEditModal from '@/views/payChanlManage/components/AddOrEditModal.vue';
import { useStore } from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTableBlock',
  emits: ['changePageTableList', 'refresh', 'sendSelect'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const columns = [{
      title: '支付渠道',
      dataIndex: 'dictDesc',
      key: 'dictDesc'
    }, {
      title: 'Paychnl',
      dataIndex: 'dictDetailCode',
      key: 'dictDetailCode'
    }, {
      title: '类型',
      dataIndex: 'payFor',
      key: 'payFor'
    }, {
      title: '回调地址后缀',
      dataIndex: 'callbackSuffix',
      key: 'callbackSuffix',
      width: 200
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right',
      width: 160
    }];
    const typeMap = {
      1: 'APP',
      2: '小游戏',
      3: 'PC'
    };
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const dataSource = ref([]),
      pageIndex = ref(1),
      pageSize = ref(20),
      pageTotal = ref(0),
      tableRef = ref(),
      editVisible = ref(false),
      editItem = ref({}),
      initMaxNum = ref(0);
    const queryList = async (queryObj = {}) => {
        let params = {
          dictCode: 'payChnl',
          pageNum: pageIndex.value,
          pageSize: pageSize.value,
          ...queryObj
        };
        try {
          const {
            code,
            data
          } = await getPayChnlList(params);
          if (code === '0') {
            dataSource.value = data.dictConfigs;
            pageTotal.value = data.dictConfigs.length;
            if (initMaxNum.value == 0 || initMaxNum.value < data.dictConfigs.length) {
              handlerSelect(data);
            }
          } else {
            dataSource.value = [];
            pageTotal.value = 0;
          }
        } catch (e) {}
      },
      refresh = () => {
        emit('refresh');
      },
      clearEditItem = () => {
        editItem.value = {};
      },
      // dataSource 手动分页
      dataSourceFilter = computed(() => {
        return dataSource.value ? dataSource.value.slice((pageIndex.value - 1) * pageSize.value, pageIndex.value * pageSize.value) : [];
      }),
      changePage = async (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        emit('changePageTableList');
      },
      handleEdit = item => {
        editItem.value = item;
        editVisible.value = true;
      },
      handlerSelect = data => {
        const channelList = [],
          payChannelList = [],
          seenChannel = new Set(),
          seenPayChannel = new Set();
        data.dictConfigs.forEach(item => {
          const {
            dictDesc,
            dictDetailCode
          } = item;
          if (dictDesc && !seenChannel.has(dictDesc)) {
            seenChannel.add(dictDesc);
            channelList.push({
              label: dictDesc,
              value: dictDesc
            });
          }
          if (dictDetailCode && !seenPayChannel.has(dictDetailCode)) {
            seenPayChannel.add(dictDetailCode);
            payChannelList.push({
              label: dictDetailCode,
              value: dictDetailCode
            });
          }
        });
        emit('sendSelect', channelList, payChannelList);
      };
    onMounted(async () => {
      await queryList();
      initMaxNum.value = pageTotal.value;
    });
    expose({
      queryList,
      pageIndex
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        class: "add-btn",
        onClick: _cache[0] || (_cache[0] = $event => handleEdit(null))
      }, {
        icon: _withCtx(() => [_createVNode(SvgIcon, {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新增 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'account',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": _unref(dataSourceFilter),
        "row-key": "key",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref3;
          return [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "link",
            onClick: $event => handleEdit(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_permission, {
            permissionValue: 'account',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]])])) : _createCommentVNode("", true), column.dataIndex === 'payFor' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(typeMap[record.dictValue.payFor]), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'callbackSuffix' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createTextVNode(_toDisplayString(record.dictValue.callbackSuffix), 1)], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[1] || (_cache[1] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(AddOrEditModal, {
        onRefresh: refresh,
        onClearEditItem: clearEditItem,
        "modal-visible": editVisible.value,
        "onUpdate:modal-visible": _cache[3] || (_cache[3] = $event => editVisible.value = $event),
        "edit-item": editItem.value
      }, null, 8, ["modal-visible", "edit-item"])]);
    };
  }
});